import { EnterpriseBuilderParametersType, QueueItemState } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { Banner, TagVariant } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';

export const stateTranslations: { [key in QueueItemState]: Mews.TextKey } = {
    [QueueItemState.Success]: TextKey.QueueItemStateSuccess,
    [QueueItemState.Processing]: TextKey.QueueItemStateProcessing,
    [QueueItemState.Warning]: TextKey.QueueItemStateWarning,
    [QueueItemState.TimedOut]: TextKey.QueueItemStateTimedOut,
    [QueueItemState.Failed]: TextKey.QueueItemStateFailed,
    [QueueItemState.Canceled]: TextKey.QueueItemStateProcessing,
    [QueueItemState.Waiting]: TextKey.QueueItemStateProcessing,
    [QueueItemState.Scheduled]: TextKey.QueueItemStateProcessing,
};

export const tooltipTranslations: { [key in QueueItemState]: Mews.TextKey } = {
    [QueueItemState.Success]: TextKey.QueueItemStateSuccessTooltip,
    [QueueItemState.Processing]: TextKey.QueueItemStateProcessingTooltip,
    [QueueItemState.Warning]: TextKey.QueueItemStateWarningTooltip,
    [QueueItemState.TimedOut]: TextKey.QueueItemStateTimedOutTooltip,
    [QueueItemState.Failed]: TextKey.QueueItemStateFailedTooltip,
    [QueueItemState.Canceled]: TextKey.QueueItemStateProcessingTooltip,
    [QueueItemState.Waiting]: TextKey.QueueItemStateProcessingTooltip,
    [QueueItemState.Scheduled]: TextKey.QueueItemStateProcessingTooltip,
};

export const tagVariants: { [key in QueueItemState]: TagVariant } = {
    [QueueItemState.Success]: 'success',
    [QueueItemState.Processing]: 'basicSubtle',
    [QueueItemState.Warning]: 'warning',
    [QueueItemState.TimedOut]: 'danger',
    [QueueItemState.Failed]: 'danger',
    [QueueItemState.Canceled]: 'warning',
    [QueueItemState.Waiting]: 'basicSubtle',
    [QueueItemState.Scheduled]: 'basicSubtle',
};
export const getInfoBanner = (state: QueueItemState, propertyType: EnterpriseBuilderParametersType) => {
    switch (state) {
        case QueueItemState.Success:
            return (
                <Banner
                    primaryText={lt('EnterpriseBuilderProSuccessBannerTitle')}
                    variant="info"
                    secondaryText={
                        propertyType === EnterpriseBuilderParametersType.NewEnterprise
                            ? lt('EnterpriseBuilderProSuccessBannerInfoNewProperty')
                            : lt('EnterpriseBuilderProSuccessBannerInfoExistingProperty')
                    }
                />
            );
        case QueueItemState.Processing:
            return (
                <Banner
                    primaryText={lt('EnterpriseBuilderProProcessing')}
                    variant="info"
                    secondaryText={lt('EnterpriseBuilderProProcessingInfo')}
                />
            );
        case QueueItemState.Warning:
            return (
                <Banner
                    primaryText={lt('EnterpriseBuilderProWarning')}
                    variant="warning"
                    secondaryText={lt('EnterpriseBuilderProWarningInfo')}
                />
            );
        case QueueItemState.TimedOut:
            return (
                <Banner
                    primaryText={lt('EnterpriseBuilderProTimedOut')}
                    variant="error"
                    secondaryText={lt('EnterpriseBuilderProTimedOutInfo')}
                />
            );
        case QueueItemState.Failed:
            return (
                <Banner
                    primaryText={lt('EnterpriseBuilderProFailed')}
                    variant="error"
                    secondaryText={lt('EnterpriseBuilderProFailedInfo')}
                />
            );
        default:
            return null;
    }
};
